import React, { createContext, useCallback, useContext, useState } from "react";

interface LogoutOverlayContextValue {
    showLogoutOverlay: () => void;
}

const LogoutOverlayContext = createContext<LogoutOverlayContextValue | null>(
    null,
);

export function useLogoutOverlay() {
    const context = useContext(LogoutOverlayContext);
    if (!context) {
        throw new Error(
            "useLogoutOverlay must be used within a LogoutOverlayProvider",
        );
    }
    return context;
}

export function LogoutOverlayProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const [isVisible, setIsVisible] = useState(false);

    const showLogoutOverlay = useCallback(() => {
        setIsVisible(true);
    }, []);

    return (
        <LogoutOverlayContext.Provider value={{ showLogoutOverlay }}>
            {children}
            {isVisible && (
                <div
                    className="fixed inset-0 z-[9999] flex items-center justify-center bg-white"
                    aria-live="polite"
                    aria-busy="true"
                >
                    <div className="text-center">
                        <div className="mb-4 inline-block h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-gray-600" />
                        <p className="text-lg font-medium text-gray-700">
                            Logging out...
                        </p>
                    </div>
                </div>
            )}
        </LogoutOverlayContext.Provider>
    );
}
